import {
  createContext,
  type ComponentPropsWithoutRef,
  type ReactNode,
} from "react";

export type MarkdownOptions = Readonly<{
  wikiPageHref?:
    | ((target: Readonly<{ relativeHref: string }>) => string)
    | undefined;
  existingPageSlugs?: ReadonlySet<string> | undefined;
  demoteHeadings?: boolean | undefined;
  variant?: "document" | "message" | "article" | undefined;
  renderLink?:
    | ((
        props: ComponentPropsWithoutRef<"a"> & Readonly<{ href: string }>,
      ) => ReactNode)
    | undefined;
}>;

export const MarkdownContext = createContext<MarkdownOptions>({});
